/*=========================================================================================
  File Name: moduleSpaceMutations.js
  Description: Space Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'

export default {
  UPDATE_TASK_STATE(state, payload){
    var index = state.tasks.findIndex(function(item){return item.id == payload.id})
    state.tasks[index].state = payload.state
  },
  UPDATE_TASK(state, payload){
    var index = state.tasks.findIndex(function(item){return item.id == payload.id})
    Object.assign(state.tasks[index], payload)
    // state.tasks[index].title = payload.title
    // state.tasks[index].state = payload.state
  },
  CREATE_TASK(state, payload){
    state.tasks.unshift(payload)
  },
  SET_TASK_LIST(state, payload){
    state.tasks = payload
  },
  DELETE_TASK(state, payload){
    var index = state.tasks.findIndex(function(item){return item.id == payload.id})
    state.tasks.splice(index,1)
  },
  SET_DONE_TASK_LIST(state, payload){
    state.doneTasks = payload
    for (var index in payload){
      // TODO: 로직 변경 필요. loop
      Vue.set(state.doneTasks[index], 'startDate', state.doneTasks[index].start_time)
      Vue.set(state.doneTasks[index], 'endDate', state.doneTasks[index].end_time)
      // console.log(state.doneTasks.user_id)
      // console.log(state.projectMembers)
      var user = state.projectMembers.find((member) => member.user_id == state.doneTasks[index].user_id)
      Vue.set(state.doneTasks[index], 'classes',  'event-'+user.color)
      Vue.set(state.doneTasks[index], 'color',  user.color)
      // state.doneTasks[index].
      // Vue.set(state.doneTasks[index], 'photo',  state.doneTasks[index].photo_url)

      // Vue.set(state.doneTasks[index], 'classes',  "color-#405DE6")
      // Vue.set(state.doneTasks[index], 'classes',  "event-#405DE6")
      // Vue.set(state.doneTasks[index], 'sytle',  'bg-#405DE6')
    }
  },
  SET_PROJECT_MEMBER(state, payload){
    var color = ['success', 'warning', 'grey', 'danger', 'primary', 'info', 'secondary']
    state.projectMembers = payload
    for(var i in payload){
      Vue.set(state.projectMembers[i], 'color', color[i%7])
    }
  },
  UPDATE_DONE_TASK(state, payload){
    // console.log(payload)
    Vue.set(payload, 'startDate', payload.start_time)
    Vue.set(payload, 'endDate', payload.end_time)
    var user = state.projectMembers.find((member) => member.user_id == payload.user_id)
    Vue.set(payload, 'classes',  'event-'+user.color)
    state.doneTasks.unshift(payload)
  },
  DELETE_DONE_TASK(state, payload){
    var index = state.doneTasks.findIndex(function(item){return item.id == payload.id})
    if(index != -1){
      state.doneTasks.splice(index,1)
    }
  },
  SET_TASK_BLOGS(state, payload){
    state.blogs = payload
  },
  SET_USER_TASKS(state, payload){
    state.userTasks = payload.sort(function(a,b) {return a.weeks > b.weeks ? -1 : a.weeks > b.weeks ? 1 : 0 })
  }
}
